import { addDoc, collection, serverTimestamp } from 'firebase/firestore'
import { db } from '~/firebase.client'
import emailjs from '@emailjs/browser'

// ── EmailJS config ──
// Sign up at https://www.emailjs.com (free 200 emails/month)
// 1. Add an email service (e.g. Hotmail/Outlook) → get SERVICE_ID
// 2. Create an email template → get TEMPLATE_ID
// 3. Get your PUBLIC_KEY from Account → API Keys
const EMAILJS_SERVICE_ID = 'service_3y6624k'
const EMAILJS_TEMPLATE_ID = 'template_94g1hzq'
const EMAILJS_PUBLIC_KEY = '52AYSwny6liYCiKse'

/**
 * Submit an enquiry — saves to Firestore + sends email notification.
 */
export async function submitEnquiry({ name, company, email, phone, service, message }) {
  // 1. Save to Firestore
  const docRef = await addDoc(collection(db, 'enquiries'), {
    name: name.trim(),
    company: company?.trim() || '',
    email: email.trim(),
    phone: phone?.trim() || '',
    service: service || '',
    message: message?.trim() || '',
    status: 'new', // new | contacted | closed
    createdAt: serverTimestamp(),
  })

  // 2. Send email notification via EmailJS
  try {
    await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      {
        from_name: name.trim(),
        from_email: email.trim(),
        company: company?.trim() || 'N/A',
        phone: phone?.trim() || 'N/A',
        service: service || 'N/A',
        message: message?.trim() || 'No message',
        to_email: 'contact@sjstechnology.in',
      },
      EMAILJS_PUBLIC_KEY,
    )
  } catch (err) {
    // Email failed but enquiry is saved — don't throw
    console.warn('EmailJS failed (enquiry still saved):', err.message)
  }

  return docRef.id
}
